import { render, staticRenderFns } from "./SettlementTicketsPDFDialog.vue?vue&type=template&id=4227d7a7&"
import script from "./SettlementTicketsPDFDialog.vue?vue&type=script&lang=js&"
export * from "./SettlementTicketsPDFDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports